import * as React from 'react';

class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: null,
      data: null, // 具体要显示的内容
    };
  }
  UNSAFE_componentWillMount() {
    //  console.log('this.props.content', this.props.content);
    if (this.props.content) {
      this.setState({ content: this.props.content }, () => {
        this.findData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.content !== this.props.content) {
      this.setState({ content: this.props.content }, () => {
        this.findData();
      });
    }
  }
  // 查找要显示的内容
  findData = () => {
    let content = this.state.content;
    if (content && content.length > 0) {
      let find = content.find(v => { return v.label === 'summary_ele' });
      if (find && find.content && find.content.length > 0) {
        let find2 = find.content.find(y => { return y.label === 'summary_text' });
        if (find2) {
          this.setState({ data: find2 }, () => {
            //  console.log(this.state.data);
          });
        }
      }
    }
  }
  render() {
    return (
      <React.Fragment>
        {
          this.state.data &&
          <div className="textlabel"
            dangerouslySetInnerHTML={{ __html: this.state.data.content }}
          />
        }
      </React.Fragment>
    );
  }
}

export default Summary;